import joinPath from '../lib/joinPath.ts';
import baseUrl from './baseUrl.ts';

export default function apiPath(...paths: (string | string[])[]) {
    if (baseUrl === '') {
        return '/' + joinPath(...paths);
    }

    return joinPath(baseUrl, ...paths);
}
